import { AssignmentClient, AssignmentResourceClient, UserAssignmentResourceClient, UserAssignmentClient, UserAssignmentEvidenceClient, UserAssignmentResourceDto } from '@greatmindsorg/dp-assignments-sdk';
import { Pageable } from '@insync-students-utils/httpConfig/index';

/* Utils */
import { Error } from '@insync-students-lib/models/error/error.model';
import { getAssignmentsServiceInstanceOptions } from '@insync-students-utils/apiConfig';
import { HttpError } from '@insync-students-lib/interfaces/error.interface';
export class AssignmentsService {
  static newInstance(options?): AssignmentsService {
    const instancesOption = getAssignmentsServiceInstanceOptions(options);
    return new AssignmentsService(AssignmentClient.newInstance(instancesOption), AssignmentResourceClient.newInstance(instancesOption), UserAssignmentClient.newInstance(instancesOption), UserAssignmentEvidenceClient.newInstance(instancesOption), UserAssignmentResourceClient.newInstance(instancesOption));
  }
  private assignmentClient: AssignmentClient;
  private assignmentResourceClient: AssignmentResourceClient;
  private userAssignmentClient: UserAssignmentClient;
  private userAssignmentEvidenceClient: UserAssignmentEvidenceClient;
  private userAssignmentResourceClient: UserAssignmentResourceClient;
  constructor(assignmentClient?: AssignmentClient, assignmentResourceClient?: AssignmentResourceClient, userAssignmentClient?: UserAssignmentClient, userAssignmentEvidenceClient?: UserAssignmentEvidenceClient, userAssignmentResourceClient?: UserAssignmentResourceClient) {
    this.assignmentClient = assignmentClient;
    this.assignmentResourceClient = assignmentResourceClient;
    this.userAssignmentClient = userAssignmentClient;
    this.userAssignmentEvidenceClient = userAssignmentEvidenceClient;
    this.userAssignmentResourceClient = userAssignmentResourceClient;
  }

  /**
   * get Assignment by ID;
   */
  getAssignment = async (id: string) => {
    try {
      const response = await this.assignmentClient.findOne(id);
      return response;
    } catch (error) {
      // TODO: handle errors
      throw error;
    }
  };

  /**
   * get Resource by Assignment ID;
   */
  async getResourceByAssignment(id: string) {
    try {
      const userAssignment = await this.userAssignmentClient.findByAssignmentAndAssignee(id);
      const dataUserAssignmentsResource = await this.userAssignmentResourceClient.findByUserAssignment(userAssignment.id);
      const UserAssignmentResource = dataUserAssignmentsResource.data[0];
      return {
        assignment: {
          ...userAssignment.assignment,
          contentId: UserAssignmentResource ? UserAssignmentResource.id : '',
          status: userAssignment.status,
          userAssignmentId: userAssignment.id
        },
        resourceId: UserAssignmentResource && UserAssignmentResource.hasOwnProperty('assignmentResource') && UserAssignmentResource.assignmentResource.resourceId || '',
        parentId: UserAssignmentResource && UserAssignmentResource.hasOwnProperty('assignmentResource') && UserAssignmentResource.assignmentResource.parentId || '',
        parentType: UserAssignmentResource && UserAssignmentResource.hasOwnProperty('assignmentResource') && UserAssignmentResource.assignmentResource.parentType || ''
      };
    } catch (err) {
      const error = err as HttpError;
      throw new Error({
        status: error.response.status,
        message: error.message
      });
    }
  }
  getAssignmentResourceClient = async (resourceIds: string[], parentId: string) => {
    try {
      const response = await this.assignmentResourceClient.findByResourceId(resourceIds, parentId, {
        limit: 20,
        skip: 0
      });
      return response;
    } catch (error) {
      // TODO: handle errors
      throw error;
    }
  };

  /**
   * startAssignment;
   */
  startAssignment = async (filters: string, id: string) => {
    try {
      const response = await this.userAssignmentClient.start(filters, id);
      return response;
    } catch (error) {
      // TODO: handle errors
      throw error;
    }
  };

  /**
   * get userAssignment by ID;
   */
  getUserAssignment = async (id: string) => {
    try {
      const response = await this.userAssignmentClient.findByAssignment(id);
      return response;
    } catch (error) {
      // TODO: handle errors
      throw error;
    }
  };

  /**
   * set Done User Assignment;
   */
  putDoneAssignment = async (assignmentId: string, userAssignmentId: string | null = null) => {
    try {
      const response = await this.userAssignmentClient.submit(userAssignmentId ?? undefined, assignmentId);
      return response;
    } catch (err) {
      const error = err as HttpError;
      throw new Error({
        status: error.response.status,
        message: error.message
      });
    }
  };

  /**
   * get getResourcesAssignments by IDs;
   */
  async getResourcesAssignments(ids: string[], classIds: string[]): Promise<Pageable<UserAssignmentResourceDto>> {
    try {
      const response = classIds?.length ? await this.userAssignmentResourceClient.findByResourceId(ids, classIds) : {
        data: [],
        options: {
          limit: 10,
          skip: 0
        }
      } as Pageable<UserAssignmentResourceDto>;
      return response;
    } catch (error) {
      // TODO: handle errors
      throw error;
    }
  }

  /**
   * send assignment evidence;
   */
  sendAssignmentEvidenceClient = async (userAssignmentId: string, files: any) => {
    try {
      const response = await this.userAssignmentEvidenceClient.upload(userAssignmentId, files);
      return response;
    } catch (err) {
      const error = err as HttpError;
      throw new Error({
        status: error.response.status,
        message: error.message
      });
    }
  };

  /**
   * Remove assignment evidence by contentId;
   */
  removeAssignmentEvidenceClient = async (contentIds: string[]) => {
    try {
      const response = await this.userAssignmentEvidenceClient.deleteByContentId(contentIds);
      return response;
    } catch (err) {
      const error = err as HttpError;
      throw new Error({
        status: error.response.status,
        message: error.message
      });
    }
  };
}